import { getSession } from "@/utils/auth";

export default class {
    constructor(user = null) {
        this.session = getSession();
        this.user = this.getUser(user);
        this.isTesterUser = this.validateIfIsTesterUser();
    }

    getUser(user) {
        if (typeof user === "undefined" || user === null)
            user = this.session?.user || null;
        return user;
    }

    validateIfIsTesterUser() {
        let local = ["0.0.0.0", "localhost", "127.0.0.1"];
        let isTesterUser = (window.isTesterUser = local.includes(
            window.location.hostname
        ));
        if (!isTesterUser) {
            isTesterUser = this.user?.is_tester || false;
        }
        return isTesterUser;
    }

    identify() {
        if (!this.isTesterUser) {
            const source = window.location.hash.split("/")[1];
            // Un analista sin empresas propias (p. ej. administracion@) no
            // tiene companies[0]: se identifica sin empresa en vez de romper
            // el login (CFO_REMOTO_FRONTEND-72).
            const company = this.user?.companies?.[0];
            window.analytics.identify(this.user.id, {
                firstName: this.user.first_name,
                lastName: this.user.last_name,
                username: this.user.username,
                email: this.user.email,
                company: company
                    ? { rut: company.rut, name: company.name }
                    : undefined,
                source: source,
            });
        }
    }

    page(name) {
        if (!this.isTesterUser) {
            window.analytics.page(name);
        }
    }

    trackLogin() {
        if (!this.isTesterUser) {
            this.identify();
            window.analytics.track("Login");
        }
    }

    trackSignUp() {
        if (!this.isTesterUser) {
            this.identify();
            window.analytics.track("SignUp");
        }
    }

    trackUploadDocument(document) {
        if (!this.isTesterUser) {
            window.analytics.track("UploadDocument", {
                documentNumber: document.document_number,
                documentType: document.document_type,
                counterpartId: document.counterpart.id,
                counterpartRut: document.counterpart.rut,
                counterpartName: document.counterpart.name,
                amount: document.amount,
            });
        }
    }

    trackUpdateDocument(document, type) {
        if (!this.isTesterUser) {
            window.analytics.track("UpdateDocument", {
                documentNumber: document.document_number,
                documentType: document.document_type,
                counterpartRut: document.counterpart.rut,
                counterpartName: document.counterpart.name,
                amount: document.amount,
                updateType: type,
            });
        }
    }

    trackUpdateMovement(movement) {
        if (!this.isTesterUser) {
            window.analytics.track("Reconciliation", {
                reconcileStatus: movement.reconcile_status,
                accountantDate: movement.accountant_date,
                financialEntity: movement.owner_account_name,
                amount: movement.amount,
            });
        }
    }

    trackRegisterChita() {
        if (!this.isTesterUser) {
            window.analytics.track("RegisterChita");
        }
    }

    trackRegisterFast() {
        if (!this.isTesterUser) {
            window.analytics.track("RegisterFast");
        }
    }

    trackLoginChita() {
        if (!this.isTesterUser) {
            window.analytics.track("LoginChita");
        }
    }

    trackDownloadDocument(data) {
        if (!this.isTesterUser) {
            window.analytics.track("DownloadN8NDocument", {
                section: data.section,
                name: data.name,
            });
        }
    }
}
